import { $, $doc, isMobile, debounceResize, throttleScroll, bodyOverflow } from './_utility';

/*------------------------------------------------------------------

  Docspress

-------------------------------------------------------------------*/
function initPluginDocspress() {
  // Collapse navigation.
  function hideCollapseChildren($collapse) {
    const $collapseMenu = $collapse.children('.children');

    $collapseMenu
      .stop()
      .css('display', 'block')
      .slideUp(300, () => {
        $collapseMenu.css('height', '');
        $collapseMenu
          .find('.page_item_has_children.show')
          .removeClass('show')
          .children('.children')
          .stop()
          .css('display', 'none');
      });

    $collapse.removeClass('show');
  }

  function showCollapseChildren($collapse) {
    const $collapseMenu = $collapse.children('.children');

    $collapseMenu
      .stop()
      .css('display', 'none')
      .slideDown(300, () => {
        $collapseMenu.css('height', '');
      });

    $collapse.addClass('show');
  }

  function setButtonCollapse() {
    $(
      '<button><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.88042 1.16967C3.58752 0.876776 3.11265 0.876777 2.81975 1.16967C2.52686 1.46256 2.52686 1.93744 2.81975 2.23033L3.88042 1.16967ZM6.64991 4.99983L7.18027 5.53013C7.47314 5.23723 7.47313 4.76238 7.18024 4.4695L6.64991 4.99983ZM2.81973 7.7697C2.52685 8.06261 2.52687 8.53748 2.81978 8.83036C3.11269 9.12324 3.58756 9.12321 3.88044 8.8303L2.81973 7.7697ZM2.81975 2.23033L6.11958 5.53016L7.18024 4.4695L3.88042 1.16967L2.81975 2.23033ZM6.11956 4.46953L2.81973 7.7697L3.88044 8.8303L7.18027 5.53013L6.11956 4.46953Z" fill="currentColor"/></svg></button>'
    ).prependTo($('.docspress-nav-list .page_item_has_children'));
  }

  function setClassCurrentPage() {
    $(`.docspress-nav-list`)
      .find('.current_page_item, .current_page_ancestor, .current_page_parent')
      .addClass('show');
  }

  setButtonCollapse();
  setClassCurrentPage();

  // Update when ajax loaded.
  $doc.on('docspress_ajax_loaded', () => {
    setButtonCollapse();
    setClassCurrentPage();
  });

  // Collapse toggle show.
  $doc.on('click', '.docspress-nav-list .page_item_has_children > button', function (e) {
    e.preventDefault();

    const $collapse = $(this).siblings('.children').parent();

    if ($collapse.length) {
      const isShowed = $collapse.hasClass('show');

      if (isShowed) {
        hideCollapseChildren($collapse);
      } else {
        showCollapseChildren($collapse);
      }
    }
  });

  // Toc.
  const currentClass = 'current';

  function toggleClassCurrent($item) {
    $item.addClass(currentClass);
    $item.siblings().removeClass(currentClass);
    $item.siblings().find(`.${currentClass}`).removeClass(currentClass);
  }

  if (!isMobile) {
    const $docSingle = $('.docspress-single');
    const $toc = $docSingle.find('.ghostkit-toc');
    const $tocLinks = $toc.find('a');
    const $contentItemId = $('.docspress-single-content .entry-content').find('[id]');
    const style = getComputedStyle(document.body);

    // Get admin bar height.
    let adminBarHeight = style.getPropertyValue('--wp-admin--admin-bar--height');

    // Update properties when window resize.
    debounceResize(() => {
      adminBarHeight = style.getPropertyValue('--wp-admin--admin-bar--height');
    });

    throttleScroll((type, scroll) => {
      let current = false;

      // Content.
      $contentItemId.each(function () {
        const $this = $(this);
        const positionTop = parseInt($this.offset().top, 10) - parseInt(adminBarHeight, 10);

        if (scroll >= positionTop) {
          current = $this.attr('id');
        }
      });

      // Links.
      $tocLinks.each(function () {
        const $item = $(this).parent();
        const $parent = $item.parents('li');
        const hash = this.hash.replace(/^#/, '');
        const insideOldCurrent = $item.find(`.${currentClass}`);

        // Toggle classes.
        if (hash === current && !$item.hasClass(currentClass)) {
          toggleClassCurrent($item);
          toggleClassCurrent($parent);
        }

        // Remove old classes inside.
        if (hash === current && insideOldCurrent.length) {
          insideOldCurrent.removeClass(currentClass);
        }

        // Remove all classes.
        if (!current) {
          $toc.find(`.${currentClass}`).removeClass(currentClass);
        }
      });
    });
  }

  // Mobile navigation.
  const $navList = $('.docspress-nav-list');
  const navButtonToggle =
    '<button class="docspress-navigation-toggle"><span></span><span></span><span></span></button>';
  let transitionEndRepeat = false;

  // Wrap navigation list.
  $('.docspress-nav-list').wrap('<div class="docspress-nav-list-wrapper"></div>');
  const $navListWrapper = $('.docspress-nav-list-wrapper');

  // Add toggle.
  $(navButtonToggle).prependTo($('.docspress-single-sidebar-wrap'));
  $(navButtonToggle).prependTo($navList);

  // Toggle show popup.
  $doc.on('click', '.docspress-navigation-toggle', function () {
    $navListWrapper.toggleClass('show');

    if ($navListWrapper.hasClass('show')) {
      bodyOverflow(1);
    }

    transitionEndRepeat = true;
  });

  $doc.on(
    'transitionend webkitTransitionEnd oTransitionEnd',
    '.docspress-nav-list-wrapper:not(.show)',
    () => {
      if (false === transitionEndRepeat) {
        return;
      }

      bodyOverflow(0);

      transitionEndRepeat = false;
    }
  );

  // Keyup escape.
  $doc.on('keyup', (e) => {
    if (27 === e.keyCode && $navListWrapper.hasClass('show')) {
      $navListWrapper.removeClass('show');

      bodyOverflow(0);

      transitionEndRepeat = true;
    }
  });
}

export { initPluginDocspress };
